// Allow only digits (max 5) in a zipcode search input. Bind in capture phase (@input.capture)
// so Multiselect reads the cleaned value
export const handleZipInput = (event) => {
  const input = event.target;
  if (input.tagName !== 'INPUT') {
    return;
  }
  const cleaned = input.value.replace(/\D/g, '').slice(0, 5);
  if (cleaned !== input.value) {
    input.value = cleaned;
  }
};

// Show numeric keyboard on mobile devices
export const handleZipFocus = (event) => {
  if (event.target.tagName === 'INPUT') {
    event.target.setAttribute('inputmode', 'numeric');
  }
};
